
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
export default {
components :{
XHeader,
Toast
},
data(){
return{
lang: "",
list: [
{ title: 'Deutsch', key: 'de', image:'static/imgs/lang/de.png' }, //德语
{ title: 'India', key: 'india', image:'static/imgs/lang/india.png' }, //印度
{ title: 'English', key: 'en', image:'static/imgs/lang/en-US.png'},//英语
{ title: 'español', key: 'es', image: 'static/imgs/lang/Spanish.png'}, //西班牙
{ title: 'Français', key: 'fr', image: 'static/imgs/lang/French.png' }, //法语
{ title: 'Italiano', key: 'italy', image:'static/imgs/lang/Italy.png' }, //意大利语
{ title: '日本語', key: 'jp', image:'static/imgs/lang/Japanese.png' }, //日语
{ title: '한국인', key: 'kor', image: 'static/imgs/lang/Korean.png'}, //汉语
{ title: 'Portugal', key: 'pt', image:'static/imgs/lang/pt.png' }, //葡萄牙
{ title: 'Tiếng Việt', key: 'vi', image: 'static/imgs/lang//vi.png'},//越南语
{ title: '繁体中文', key: 'cn', image: 'static/imgs/lang//taiwan.png'},  //简体中文
{ title: '简体中文', key: 'zh', image: 'static/imgs/lang//zh-CN.png'},//繁体中文
{ title: 'Ελληνικά', key: 'gr', image: 'static/imgs/lang//Greek.png'}, //希腊语
{ title: 'ไทย', key: 'th', image: 'static/imgs/lang//Thai.png'}, //泰语
]
}
},
created(){
this.lang = this.$i18n.locale || 'en'
},
methods: {
changeLang(lang){
window.localStorage.setItem("locale", lang);
this.$i18n.locale = lang;
this.lang = lang
window.localStorage.setItem("lang", lang);
this.setCookie('lang', lang, 30)
},
setCookie(cname, cvalue, exdays) {

var d = new Date();

d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);

var expires = "expires=" + d.toUTCString();

console.info(cname + "=" + cvalue + "; " + expires);

document.cookie = cname + "=" + cvalue + "; " + expires;

console.info(document.cookie);

}

}
}



// WEBPACK FOOTER //
// ./src/pages/lang.vue